module.exports = __webpack_public_path__ + "static/media/graph.986f694f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/landing/graph.png
// module id = 1257
// module chunks = 0